export default "__VITE_PUBLIC_ASSET__c42c33fd__"